
// 2024 Topps Chrome Star Wars
// Base parallels
const BASE_P = [
  { id: 'rainbow', name: 'Rainbow Refractor', color: '#e0c8ff' },
  { id: 'blue-blaster', name: 'Blue Blaster Pulsar Refractor', color: '#4fc3f7' },
  { id: 'red-blaster', name: 'Red Blaster RayWave Refractor', color: '#ff6b6b' },
  { id: 'kamino-aqua', name: 'Kamino Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'skywalker-blue', name: 'Skywalker Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'kashyyyk-green', name: 'Kashyyyk Green Refractor', print_run: 99, color: '#00e87a' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'mustafar-lava', name: 'Mustafar Lava Refractor', print_run: 10, color: '#ff3d00' },
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#616161' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Aurebesh Variation parallels
const AV_P = [
  // Rule-6 serial slot: the base Aurebesh Variation is itself /99, so without this
  // there is no way to record which copy you own. Blank name renders as "#'d /99".
  { id: 'base', name: '', print_run: 99, color: '#c8d8f0' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'mustafar-lava', name: 'Mustafar Lava Refractor', print_run: 10, color: '#ff3d00' },
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Hoth FrozenFractor parallels — 6 unnumbered 1/1 variants per card
// Topps numbers them -5, -4, -3, -2, -1, 0 (six values); ids kept stable for
// collector-data safety, only names updated to match real Topps notation.
const HV_P = [
  { id: 'hoth-1', name: 'Hoth Ice Blue FrozenFractor -1/0', print_run: 1, color: '#a0d4ff' },
  { id: 'hoth-2', name: 'Hoth Ice Blue FrozenFractor -2/0', print_run: 1, color: '#80c4ff' },
  { id: 'hoth-3', name: 'Hoth Ice Blue FrozenFractor -3/0', print_run: 1, color: '#60b4ff' },
  { id: 'hoth-4', name: 'Hoth Ice Blue FrozenFractor -4/0', print_run: 1, color: '#40a4ff' },
  { id: 'hoth-5', name: 'Hoth Ice Blue FrozenFractor -5/0', print_run: 1, color: '#2090e8' },
  { id: 'hoth-6', name: 'Hoth Ice Blue FrozenFractor 0/0', print_run: 1, color: '#0070c8' },
];

// Standard insert/auto parallels (Green/99 down to Superfractor)
const INS_P = [
  { id: 'kashyyyk-green', name: 'Kashyyyk Green Refractor', print_run: 99, color: '#00e87a' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'mustafar-lava', name: 'Mustafar Lava Refractor', print_run: 10, color: '#ff3d00' },
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Gold/Orange/Lava/Red/Super (for I Love You I Know, Starship Blueprints)
const INS_P2 = [
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'mustafar-lava', name: 'Mustafar Lava Refractor', print_run: 10, color: '#ff3d00' },
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Reflections: base + superfractor
const REFL_P = [
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Bonus Stage: Superfractor /1 (Topps convention; confirmed via BreakNinja)
const BS_P = [
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Single auto parallels
const AUTO_P = [
  { id: 'kamino-aqua', name: 'Kamino Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'skywalker-blue', name: 'Skywalker Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'kashyyyk-green', name: 'Kashyyyk Green Refractor', print_run: 99, color: '#00e87a' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'mustafar-lava', name: 'Mustafar Lava Refractor', print_run: 10, color: '#ff3d00' },
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Dual/Triple auto parallels
const MULTI_AUTO_P = [
  { id: 'dathomir-red', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 150 CARDS', parallels: BASE_P,
    cards: [
      {n:'1', name:'Ahsoka Tano'},
      {n:'2', name:'Hera Syndulla'},
      {n:'3', name:'Sabine Wren'},
      {n:'4', name:'Grand Admiral Thrawn'},
      {n:'5', name:'Baylan Skoll'},
      {n:'6', name:'Shin Hati'},
      {n:'7', name:'Cassian Andor'},
      {n:'8', name:'Mon Mothma'},
      {n:'9', name:'Luthen Rael'},
      {n:'10', name:'Bix Caleen'},
      {n:'11', name:'Kino Loy'},
      {n:'12', name:'Syril Karn'},
      {n:'13', name:'Maarva Andor'},
      {n:'14', name:'Dedra Meero'},
      {n:'15', name:'Vel Sartha'},
      {n:'16', name:'Cinta Kaz'},
      {n:'17', name:'Saw Gerrera'},
      {n:'18', name:'B2EMO'},
      {n:'19', name:'Boba Fett'},
      {n:'20', name:'Fennec Shand'},
      {n:'21', name:'The Mandalorian'},
      {n:'22', name:'Grogu'},
      {n:'23', name:'8D8'},
      {n:'24', name:'Twi\'lek Majordomo'},
      {n:'25', name:'Garsa Fwip'},
      {n:'26', name:'Krrsantan'},
      {n:'27', name:'The Twins'},
      {n:'28', name:'Drash'},
      {n:'29', name:'Skad'},
      {n:'30', name:'The Modifier'},
      {n:'31', name:'Peli Motto'},
      {n:'32', name:'Cobb Vanth'},
      {n:'33', name:'Cad Bane'},
      {n:'34', name:'Camie'},
      {n:'35', name:'Fixer'},
      {n:'36', name:'Carson Teva'},
      {n:'37', name:'Moff Gideon'},
      {n:'38', name:'Bo-Katan Kryze'},
      {n:'39', name:'The Armorer'},
      {n:'40', name:'IG-12'},
      {n:'41', name:'IG-11'},
      {n:'42', name:'Mayfeld'},
      {n:'43', name:'Greef Karga'},
      {n:'44', name:'The Client'},
      {n:'45', name:'Kuiil'},
      {n:'46', name:'Koska Reeves'},
      {n:'47', name:'Elia Kane'},
      {n:'48', name:'Axe Woves'},
      {n:'49', name:'Paz Vizsla'},
      {n:'50', name:'Toro Calican'},
      {n:'51', name:'Ranzar Malk'},
      {n:'52', name:'Commissioner Helgait'},
      {n:'53', name:'The Duchess'},
      {n:'54', name:'Captain Bombardier'},
      {n:'55', name:'Colonel Tuttle'},
      {n:'56', name:'Kelleran Beq'},
      {n:'57', name:'Morgan Elsbeth'},
      {n:'58', name:'Qin'},
      {n:'59', name:'Xi\'an'},
      {n:'60', name:'Burg'},
      {n:'61', name:'Q9-0'},
      {n:'62', name:'Gorian Shard'},
      {n:'63', name:'Boba Fett\'s Rancor'},
      {n:'64', name:'Rancor Keeper'},
      {n:'65', name:'Tatooine Sand Beast'},
      {n:'66', name:'Darth Vader'},
      {n:'67', name:'Obi-Wan Kenobi'},
      {n:'68', name:'Reva'},
      {n:'69', name:'Princess Leia'},
      {n:'70', name:'Luke Skywalker'},
      {n:'71', name:'Uncle Owen'},
      {n:'72', name:'Aunt Beru'},
      {n:'73', name:'Breha Organa'},
      {n:'74', name:'Bail Organa'},
      {n:'75', name:'Vect Nokru'},
      {n:'76', name:'L0LA'},
      {n:'77', name:'Fifth Brother'},
      {n:'78', name:'The Grand Inquisitor'},
      {n:'79', name:'Haja Estree'},
      {n:'80', name:'Fourth Sister'},
      {n:'81', name:'Freck'},
      {n:'82', name:'Purge Trooper'},
      {n:'83', name:'Tala Durith'},
      {n:'84', name:'NED-B'},
      {n:'85', name:'Vane'},
      {n:'86', name:'Praetorian Guard'},
      {n:'87', name:'Pit Droid'},
      {n:'88', name:'R5-D4'},
      {n:'89', name:'Mudhorn'},
      {n:'90', name:'Freedi Pamular'},
      {n:'91', name:'Doctor Quadpaw'},
      {n:'92', name:'Nurchi'},
      {n:'93', name:'Salman Paak'},
      {n:'94', name:'Steelpecker'},
      {n:'95', name:'Corellian Hound'},
      {n:'96', name:'Leida Mothma'},
      {n:'97', name:'Perrin Fertha'},
      {n:'98', name:'Melshi'},
      {n:'99', name:'Captain Enoch'},
      {n:'100', name:'Jacen Syndulla'},
      {n:'101', name:'K-2SO'},
      {n:'102', name:'Han Solo'},
      {n:'103', name:'Leia Organa'},
      {n:'104', name:'Luke Skywalker'},
      {n:'105', name:'Wedge Antilles'},
      {n:'106', name:'Lando Calrissian'},
      {n:'107', name:'Chewbacca'},
      {n:'108', name:'R2-D2'},
      {n:'109', name:'C-3PO'},
      {n:'110', name:'BB-8'},
      {n:'111', name:'D-0'},
      {n:'112', name:'Rey'},
      {n:'113', name:'Finn'},
      {n:'114', name:'Poe Dameron'},
      {n:'115', name:'Kylo Ren'},
      {n:'116', name:'General Hux'},
      {n:'117', name:'Supreme Leader Snoke'},
      {n:'118', name:'Jabba The Hutt'},
      {n:'119', name:'Jyn Erso'},
      {n:'120', name:'Director Krennic'},
      {n:'121', name:'Admiral Ackbar'},
      {n:'122', name:'Nien Nunb'},
      {n:'123', name:'Wicket W. Warrick'},
      {n:'124', name:'Kanan Jarrus'},
      {n:'125', name:'Ezra Bridger'},
      {n:'126', name:'Zeb Orrelios'},
      {n:'127', name:'Jar Jar Binks'},
      {n:'128', name:'Qui-Gon Jinn'},
      {n:'129', name:'Count Dooku'},
      {n:'130', name:'Padmé Amidala'},
      {n:'131', name:'Emperor Palpatine'},
      {n:'132', name:'Sebulba'},
      {n:'133', name:'Captain Phasma'},
      {n:'134', name:'Maz Kanata'},
      {n:'135', name:'General Grievous'},
      {n:'136', name:'Asajj Ventress'},
      {n:'137', name:'Captain Rex'},
      {n:'138', name:'Mace Windu'},
      {n:'139', name:'Jango Fett'},
      {n:'140', name:'Yoda'},
      {n:'141', name:'Kit Fisto'},
      {n:'142', name:'Dexter Jettster'},
      {n:'143', name:'Aayla Secura'},
      {n:'144', name:'Barriss Offee'},
      {n:'145', name:'Luminara Unduli'},
      {n:'146', name:'Saesee Tiin'},
      {n:'147', name:'Plo Koon'},
      {n:'148', name:'Aurra Sing'},
      {n:'149', name:'Dryden Vos'},
      {n:'150', name:'Qi\'ra'},
    ]
  },
  {
    id: 'aurebesh-variations', type: 'base',
    title: 'AUREBESH SHORT PRINT VARIATIONS — 150 CARDS',
    // The base Aurebesh Variation is itself a /99 short print (all AVs are /99);
    // the scanner labels its base option "Base /99" instead of "no parallel".
    basePrintRun: 99,
    parallels: AV_P,
    cards: [
      {n:'AV-1', name:'Ahsoka Tano'},
      {n:'AV-2', name:'Hera Syndulla'},
      {n:'AV-3', name:'Sabine Wren'},
      {n:'AV-4', name:'Grand Admiral Thrawn'},
      {n:'AV-5', name:'Baylan Skoll'},
      {n:'AV-6', name:'Shin Hati'},
      {n:'AV-7', name:'Cassian Andor'},
      {n:'AV-8', name:'Mon Mothma'},
      {n:'AV-9', name:'Luthen Rael'},
      {n:'AV-10', name:'Bix Caleen'},
      {n:'AV-11', name:'Kino Loy'},
      {n:'AV-12', name:'Syril Karn'},
      {n:'AV-13', name:'Maarva Andor'},
      {n:'AV-14', name:'Dedra Meero'},
      {n:'AV-15', name:'Vel Sartha'},
      {n:'AV-16', name:'Cinta Kaz'},
      {n:'AV-17', name:'Saw Gerrera'},
      {n:'AV-18', name:'B2EMO'},
      {n:'AV-19', name:'Boba Fett'},
      {n:'AV-20', name:'Fennec Shand'},
      {n:'AV-21', name:'The Mandalorian'},
      {n:'AV-22', name:'Grogu'},
      {n:'AV-23', name:'8D8'},
      {n:'AV-24', name:'Twi\'lek Majordomo'},
      {n:'AV-25', name:'Garsa Fwip'},
      {n:'AV-26', name:'Krrsantan'},
      {n:'AV-27', name:'The Twins'},
      {n:'AV-28', name:'Drash'},
      {n:'AV-29', name:'Skad'},
      {n:'AV-30', name:'The Modifier'},
      {n:'AV-31', name:'Peli Motto'},
      {n:'AV-32', name:'Cobb Vanth'},
      {n:'AV-33', name:'Cad Bane'},
      {n:'AV-34', name:'Camie'},
      {n:'AV-35', name:'Fixer'},
      {n:'AV-36', name:'Carson Teva'},
      {n:'AV-37', name:'Moff Gideon'},
      {n:'AV-38', name:'Bo-Katan Kryze'},
      {n:'AV-39', name:'The Armorer'},
      {n:'AV-40', name:'IG-12'},
      {n:'AV-41', name:'IG-11'},
      {n:'AV-42', name:'Mayfeld'},
      {n:'AV-43', name:'Greef Karga'},
      {n:'AV-44', name:'The Client'},
      {n:'AV-45', name:'Kuiil'},
      {n:'AV-46', name:'Koska Reeves'},
      {n:'AV-47', name:'Elia Kane'},
      {n:'AV-48', name:'Axe Woves'},
      {n:'AV-49', name:'Paz Vizsla'},
      {n:'AV-50', name:'Toro Calican'},
      {n:'AV-51', name:'Ranzar Malk'},
      {n:'AV-52', name:'Commissioner Helgait'},
      {n:'AV-53', name:'The Duchess'},
      {n:'AV-54', name:'Captain Bombardier'},
      {n:'AV-55', name:'Colonel Tuttle'},
      {n:'AV-56', name:'Kelleran Beq'},
      {n:'AV-57', name:'Morgan Elsbeth'},
      {n:'AV-58', name:'Qin'},
      {n:'AV-59', name:'Xi\'an'},
      {n:'AV-60', name:'Burg'},
      {n:'AV-61', name:'Q9-0'},
      {n:'AV-62', name:'Gorian Shard'},
      {n:'AV-63', name:'Boba Fett\'s Rancor'},
      {n:'AV-64', name:'Rancor Keeper'},
      {n:'AV-65', name:'Tatooine Sand Beast'},
      {n:'AV-66', name:'Darth Vader'},
      {n:'AV-67', name:'Obi-Wan Kenobi'},
      {n:'AV-68', name:'Reva'},
      {n:'AV-69', name:'Princess Leia'},
      {n:'AV-70', name:'Luke Skywalker'},
      {n:'AV-71', name:'Uncle Owen'},
      {n:'AV-72', name:'Aunt Beru'},
      {n:'AV-73', name:'Breha Organa'},
      {n:'AV-74', name:'Bail Organa'},
      {n:'AV-75', name:'Vect Nokru'},
      {n:'AV-76', name:'L0LA'},
      {n:'AV-77', name:'Fifth Brother'},
      {n:'AV-78', name:'The Grand Inquisitor'},
      {n:'AV-79', name:'Haja Estree'},
      {n:'AV-80', name:'Fourth Sister'},
      {n:'AV-81', name:'Freck'},
      {n:'AV-82', name:'Purge Trooper'},
      {n:'AV-83', name:'Tala Durith'},
      {n:'AV-84', name:'NED-B'},
      {n:'AV-85', name:'Vane'},
      {n:'AV-86', name:'Praetorian Guard'},
      {n:'AV-87', name:'Pit Droid'},
      {n:'AV-88', name:'R5-D4'},
      {n:'AV-89', name:'Mudhorn'},
      {n:'AV-90', name:'Freedi Pamular'},
      {n:'AV-91', name:'Doctor Quadpaw'},
      {n:'AV-92', name:'Nurchi'},
      {n:'AV-93', name:'Salman Paak'},
      {n:'AV-94', name:'Steelpecker'},
      {n:'AV-95', name:'Corellian Hound'},
      {n:'AV-96', name:'Leida Mothma'},
      {n:'AV-97', name:'Perrin Fertha'},
      {n:'AV-98', name:'Melshi'},
      {n:'AV-99', name:'Captain Enoch'},
      {n:'AV-100', name:'Jacen Syndulla'},
      {n:'AV-101', name:'K-2SO'},
      {n:'AV-102', name:'Han Solo'},
      {n:'AV-103', name:'Leia Organa'},
      {n:'AV-104', name:'Luke Skywalker'},
      {n:'AV-105', name:'Wedge Antilles'},
      {n:'AV-106', name:'Lando Calrissian'},
      {n:'AV-107', name:'Chewbacca'},
      {n:'AV-108', name:'R2-D2'},
      {n:'AV-109', name:'C-3PO'},
      {n:'AV-110', name:'BB-8'},
      {n:'AV-111', name:'D-0'},
      {n:'AV-112', name:'Rey'},
      {n:'AV-113', name:'Finn'},
      {n:'AV-114', name:'Poe Dameron'},
      {n:'AV-115', name:'Kylo Ren'},
      {n:'AV-116', name:'General Hux'},
      {n:'AV-117', name:'Supreme Leader Snoke'},
      {n:'AV-118', name:'Jabba The Hutt'},
      {n:'AV-119', name:'Jyn Erso'},
      {n:'AV-120', name:'Director Krennic'},
      {n:'AV-121', name:'Admiral Ackbar'},
      {n:'AV-122', name:'Nien Nunb'},
      {n:'AV-123', name:'Wicket W. Warrick'},
      {n:'AV-124', name:'Kanan Jarrus'},
      {n:'AV-125', name:'Ezra Bridger'},
      {n:'AV-126', name:'Zeb Orrelios'},
      {n:'AV-127', name:'Jar Jar Binks'},
      {n:'AV-128', name:'Qui-Gon Jinn'},
      {n:'AV-129', name:'Count Dooku'},
      {n:'AV-130', name:'Padmé Amidala'},
      {n:'AV-131', name:'Emperor Palpatine'},
      {n:'AV-132', name:'Sebulba'},
      {n:'AV-133', name:'Captain Phasma'},
      {n:'AV-134', name:'Maz Kanata'},
      {n:'AV-135', name:'General Grievous'},
      {n:'AV-136', name:'Asajj Ventress'},
      {n:'AV-137', name:'Captain Rex'},
      {n:'AV-138', name:'Mace Windu'},
      {n:'AV-139', name:'Jango Fett'},
      {n:'AV-140', name:'Yoda'},
      {n:'AV-141', name:'Kit Fisto'},
      {n:'AV-142', name:'Dexter Jettster'},
      {n:'AV-143', name:'Aayla Secura'},
      {n:'AV-144', name:'Barriss Offee'},
      {n:'AV-145', name:'Luminara Unduli'},
      {n:'AV-146', name:'Saesee Tiin'},
      {n:'AV-147', name:'Plo Koon'},
      {n:'AV-148', name:'Aurra Sing'},
      {n:'AV-149', name:'Dryden Vos'},
      {n:'AV-150', name:'Qi\'ra'},
    ]
  },
  {
    id: 'hoth-frozenfractor', type: 'base',
    title: 'HOTH ICE BLUE FROZENFRACTOR SUPER SHORT PRINTS — 150 CARDS',
    parallels: HV_P,
    cards: [
      {n:'HV-1', name:'Ahsoka Tano'},
      {n:'HV-2', name:'Hera Syndulla'},
      {n:'HV-3', name:'Sabine Wren'},
      {n:'HV-4', name:'Grand Admiral Thrawn'},
      {n:'HV-5', name:'Baylan Skoll'},
      {n:'HV-6', name:'Shin Hati'},
      {n:'HV-7', name:'Cassian Andor'},
      {n:'HV-8', name:'Mon Mothma'},
      {n:'HV-9', name:'Luthen Rael'},
      {n:'HV-10', name:'Bix Caleen'},
      {n:'HV-11', name:'Kino Loy'},
      {n:'HV-12', name:'Syril Karn'},
      {n:'HV-13', name:'Maarva Andor'},
      {n:'HV-14', name:'Dedra Meero'},
      {n:'HV-15', name:'Vel Sartha'},
      {n:'HV-16', name:'Cinta Kaz'},
      {n:'HV-17', name:'Saw Gerrera'},
      {n:'HV-18', name:'B2EMO'},
      {n:'HV-19', name:'Boba Fett'},
      {n:'HV-20', name:'Fennec Shand'},
      {n:'HV-21', name:'The Mandalorian'},
      {n:'HV-22', name:'Grogu'},
      {n:'HV-23', name:'8D8'},
      {n:'HV-24', name:'Twi\'lek Majordomo'},
      {n:'HV-25', name:'Garsa Fwip'},
      {n:'HV-26', name:'Krrsantan'},
      {n:'HV-27', name:'The Twins'},
      {n:'HV-28', name:'Drash'},
      {n:'HV-29', name:'Skad'},
      {n:'HV-30', name:'The Modifier'},
      {n:'HV-31', name:'Peli Motto'},
      {n:'HV-32', name:'Cobb Vanth'},
      {n:'HV-33', name:'Cad Bane'},
      {n:'HV-34', name:'Camie'},
      {n:'HV-35', name:'Fixer'},
      {n:'HV-36', name:'Carson Teva'},
      {n:'HV-37', name:'Moff Gideon'},
      {n:'HV-38', name:'Bo-Katan Kryze'},
      {n:'HV-39', name:'The Armorer'},
      {n:'HV-40', name:'IG-12'},
      {n:'HV-41', name:'IG-11'},
      {n:'HV-42', name:'Mayfeld'},
      {n:'HV-43', name:'Greef Karga'},
      {n:'HV-44', name:'The Client'},
      {n:'HV-45', name:'Kuiil'},
      {n:'HV-46', name:'Koska Reeves'},
      {n:'HV-47', name:'Elia Kane'},
      {n:'HV-48', name:'Axe Woves'},
      {n:'HV-49', name:'Paz Vizsla'},
      {n:'HV-50', name:'Toro Calican'},
      {n:'HV-51', name:'Ranzar Malk'},
      {n:'HV-52', name:'Commissioner Helgait'},
      {n:'HV-53', name:'The Duchess'},
      {n:'HV-54', name:'Captain Bombardier'},
      {n:'HV-55', name:'Colonel Tuttle'},
      {n:'HV-56', name:'Kelleran Beq'},
      {n:'HV-57', name:'Morgan Elsbeth'},
      {n:'HV-58', name:'Qin'},
      {n:'HV-59', name:'Xi\'an'},
      {n:'HV-60', name:'Burg'},
      {n:'HV-61', name:'Q9-0'},
      {n:'HV-62', name:'Gorian Shard'},
      {n:'HV-63', name:'Boba Fett\'s Rancor'},
      {n:'HV-64', name:'Rancor Keeper'},
      {n:'HV-65', name:'Tatooine Sand Beast'},
      {n:'HV-66', name:'Darth Vader'},
      {n:'HV-67', name:'Obi-Wan Kenobi'},
      {n:'HV-68', name:'Reva'},
      {n:'HV-69', name:'Princess Leia'},
      {n:'HV-70', name:'Luke Skywalker'},
      {n:'HV-71', name:'Uncle Owen'},
      {n:'HV-72', name:'Aunt Beru'},
      {n:'HV-73', name:'Breha Organa'},
      {n:'HV-74', name:'Bail Organa'},
      {n:'HV-75', name:'Vect Nokru'},
      {n:'HV-76', name:'L0LA'},
      {n:'HV-77', name:'Fifth Brother'},
      {n:'HV-78', name:'The Grand Inquisitor'},
      {n:'HV-79', name:'Haja Estree'},
      {n:'HV-80', name:'Fourth Sister'},
      {n:'HV-81', name:'Freck'},
      {n:'HV-82', name:'Purge Trooper'},
      {n:'HV-83', name:'Tala Durith'},
      {n:'HV-84', name:'NED-B'},
      {n:'HV-85', name:'Vane'},
      {n:'HV-86', name:'Praetorian Guard'},
      {n:'HV-87', name:'Pit Droid'},
      {n:'HV-88', name:'R5-D4'},
      {n:'HV-89', name:'Mudhorn'},
      {n:'HV-90', name:'Freedi Pamular'},
      {n:'HV-91', name:'Doctor Quadpaw'},
      {n:'HV-92', name:'Nurchi'},
      {n:'HV-93', name:'Salman Paak'},
      {n:'HV-94', name:'Steelpecker'},
      {n:'HV-95', name:'Corellian Hound'},
      {n:'HV-96', name:'Leida Mothma'},
      {n:'HV-97', name:'Perrin Fertha'},
      {n:'HV-98', name:'Melshi'},
      {n:'HV-99', name:'Captain Enoch'},
      {n:'HV-100', name:'Jacen Syndulla'},
      {n:'HV-101', name:'K-2SO'},
      {n:'HV-102', name:'Han Solo'},
      {n:'HV-103', name:'Leia Organa'},
      {n:'HV-104', name:'Luke Skywalker'},
      {n:'HV-105', name:'Wedge Antilles'},
      {n:'HV-106', name:'Lando Calrissian'},
      {n:'HV-107', name:'Chewbacca'},
      {n:'HV-108', name:'R2-D2'},
      {n:'HV-109', name:'C-3PO'},
      {n:'HV-110', name:'BB-8'},
      {n:'HV-111', name:'D-0'},
      {n:'HV-112', name:'Rey'},
      {n:'HV-113', name:'Finn'},
      {n:'HV-114', name:'Poe Dameron'},
      {n:'HV-115', name:'Kylo Ren'},
      {n:'HV-116', name:'General Hux'},
      {n:'HV-117', name:'Supreme Leader Snoke'},
      {n:'HV-118', name:'Jabba The Hutt'},
      {n:'HV-119', name:'Jyn Erso'},
      {n:'HV-120', name:'Director Krennic'},
      {n:'HV-121', name:'Admiral Ackbar'},
      {n:'HV-122', name:'Nien Nunb'},
      {n:'HV-123', name:'Wicket W. Warrick'},
      {n:'HV-124', name:'Kanan Jarrus'},
      {n:'HV-125', name:'Ezra Bridger'},
      {n:'HV-126', name:'Zeb Orrelios'},
      {n:'HV-127', name:'Jar Jar Binks'},
      {n:'HV-128', name:'Qui-Gon Jinn'},
      {n:'HV-129', name:'Count Dooku'},
      {n:'HV-130', name:'Padmé Amidala'},
      {n:'HV-131', name:'Emperor Palpatine'},
      {n:'HV-132', name:'Sebulba'},
      {n:'HV-133', name:'Captain Phasma'},
      {n:'HV-134', name:'Maz Kanata'},
      {n:'HV-135', name:'General Grievous'},
      {n:'HV-136', name:'Asajj Ventress'},
      {n:'HV-137', name:'Captain Rex'},
      {n:'HV-138', name:'Mace Windu'},
      {n:'HV-139', name:'Jango Fett'},
      {n:'HV-140', name:'Yoda'},
      {n:'HV-141', name:'Kit Fisto'},
      {n:'HV-142', name:'Dexter Jettster'},
      {n:'HV-143', name:'Aayla Secura'},
      {n:'HV-144', name:'Barriss Offee'},
      {n:'HV-145', name:'Luminara Unduli'},
      {n:'HV-146', name:'Saesee Tiin'},
      {n:'HV-147', name:'Plo Koon'},
      {n:'HV-148', name:'Aurra Sing'},
      {n:'HV-149', name:'Dryden Vos'},
      {n:'HV-150', name:'Qi\'ra'},
    ]
  },
  {
    id: 'bonus-stage', type: 'insert', title: 'BONUS STAGE — 10 CARDS',
    parallels: BS_P,
    cards: [
      {n:'BS-AS', name:'Anakin Skywalker'},
      {n:'BS-AT', name:'Ahsoka Tano'},
      {n:'BS-C', name:'Chewbacca'},
      {n:'BS-EB', name:'Ezra Bridger'},
      {n:'BS-HO', name:'Captain Rex'},
      {n:'BS-KJ', name:'Kanan Jarrus'},
      {n:'BS-OK', name:'Obi-Wan Kenobi'},
      {n:'BS-R', name:'Rey'},
      {n:'BS-SW', name:'Sabine Wren'},
      {n:'BS-Y', name:'Yoda'},
    ]
  },
  {
    id: 'galactic-empire', type: 'insert',
    title: 'THE GALACTIC CIVIL WAR — GALACTIC EMPIRE — 9 CARDS',
    parallels: INS_P,
    cards: [
      {n:'GE-1', name:'Darth Vader'},
      {n:'GE-2', name:'Emperor Palpatine'},
      {n:'GE-3', name:'Director Orson Krennic'},
      {n:'GE-4', name:'Grand Moff Tarkin'},
      {n:'GE-5', name:'Admiral Ozzel'},
      {n:'GE-6', name:'Admiral Piett'},
      {n:'GE-7', name:'Admiral Motti'},
      {n:'GE-8', name:'Imperial Royal Guards'},
      {n:'GE-9', name:'Stormtrooper'},
    ]
  },
  {
    id: 'rebel-alliance', type: 'insert',
    title: 'THE GALACTIC CIVIL WAR — REBEL ALLIANCE — 9 CARDS',
    parallels: INS_P,
    cards: [
      {n:'RA-1', name:'Leia Organa'},
      {n:'RA-2', name:'Luke Skywalker'},
      {n:'RA-3', name:'Han Solo'},
      {n:'RA-4', name:'Chewbacca'},
      {n:'RA-5', name:'Lando Calrissian'},
      {n:'RA-6', name:'C-3PO'},
      {n:'RA-7', name:'Cassian Andor'},
      {n:'RA-8', name:'R2-D2'},
      {n:'RA-9', name:'Jyn Erso'},
    ]
  },
  {
    id: 'galactic-gear', type: 'insert', title: 'GALACTIC GEAR — 25 CARDS',
    parallels: INS_P,
    cards: [
      {n:'GG-1', name:'Lando Calrissian'},
      {n:'GG-2', name:'Lando Calrissian'},
      {n:'GG-3', name:'Han Solo'},
      {n:'GG-4', name:'Leia Organa'},
      {n:'GG-5', name:'Luke Skywalker'},
      {n:'GG-6', name:'Captain Phasma'},
      {n:'GG-7', name:'Darth Vader'},
      {n:'GG-8', name:'Darth Maul'},
      {n:'GG-9', name:'Kelleran Beq'},
      {n:'GG-10', name:'The Dutchess'},
      {n:'GG-11', name:'Queen Amidala'},
      {n:'GG-12', name:'Padmé Amidala'},
      {n:'GG-13', name:"Qi\'ra"},
      {n:'GG-14', name:'Han Solo'},
      {n:'GG-15', name:'Lando Calrissian'},
      {n:'GG-16', name:'Count Dooku'},
      {n:'GG-17', name:'Padmé Amidala'},
      {n:'GG-18', name:'Anakin Skywalker'},
      {n:'GG-19', name:'Leia Organa'},
      {n:'GG-20', name:'Fennec Shand'},
      {n:'GG-21', name:'Boba Fett'},
      {n:'GG-22', name:'Poe Dameron'},
      {n:'GG-23', name:'Finn'},
      {n:'GG-24', name:'Kylo Ren'},
      {n:'GG-25', name:'Ahsoka Tano'},
    ]
  },
  {
    id: 'the-heiress', type: 'insert', title: 'THE HEIRESS — 10 CARDS',
    parallels: INS_P,
    cards: [
      {n:'TH-1', name:'Bo-Katan Reassures Grogu'},
      {n:'TH-2', name:'Bo-Katan Pursues the Raptor'},
      {n:'TH-3', name:'Bo-Katan Leads the Rescue Mission'},
      {n:'TH-4', name:'Bo-Katan Plans the Route'},
      {n:'TH-5', name:'Bo-Katan Wields the Darksaber'},
      {n:'TH-6', name:'Bo-Katan Rescues The Mandalorian'},
      {n:'TH-7', name:'Bo-Katan Fends Off Attackers'},
      {n:'TH-8', name:'The Team Arrives at the Secret Enclave'},
      {n:'TH-9', name:'Bo-Katan Begins the Search for Mando'},
      {n:'TH-10', name:'Bo-Katan Brings Grogu for the Ride'},
    ]
  },
  {
    id: 'i-love-you-i-know', type: 'insert', title: 'I LOVE YOU...I KNOW — 20 CARDS',
    parallels: INS_P2,
    cards: [
      {n:'ILY-1A', name:'Rescuing The Princess'},
      {n:'ILY-1B', name:'Rescuing The Princess'},
      {n:'ILY-2A', name:'The Medal Ceremony'},
      {n:'ILY-2B', name:'The Medal Ceremony'},
      {n:'ILY-3A', name:'Evacuation on Hoth'},
      {n:'ILY-3B', name:'Evacuation on Hoth'},
      {n:'ILY-4A', name:'Asteroid Field'},
      {n:'ILY-4B', name:'Asteroid Field'},
      {n:'ILY-5A', name:'The Carbonite Chamber'},
      {n:'ILY-5B', name:'The Carbonite Chamber'},
      {n:'ILY-6A', name:'Rescuing the Scoundrel'},
      {n:'ILY-6B', name:'Rescuing the Scoundrel'},
      {n:'ILY-7A', name:'In the Ewok Village'},
      {n:'ILY-7B', name:'In the Ewok Village'},
      {n:'ILY-8A', name:'The Endor Bunker'},
      {n:'ILY-8B', name:'The Endor Bunker'},
      {n:'ILY-9A', name:'Reunion on Takodana'},
      {n:'ILY-9B', name:'Reunion on Takodana'},
      {n:'ILY-10A', name:'Rescuing Their Son'},
      {n:'ILY-10B', name:'Rescuing Their Son'},
    ]
  },
  {
    id: 'reflections', type: 'insert', title: 'REFLECTIONS — 5 CARDS',
    parallels: REFL_P,
    cards: [
      {n:'R-1', name:'Imperial Stormtrooper'},
      {n:'R-2', name:'R2-D2'},
      {n:'R-3', name:'Darth Vader'},
      {n:'R-4', name:'Greedo'},
      {n:'R-5', name:'Boba Fett'},
    ]
  },
  {
    id: 'rise-of-palpatine', type: 'insert', title: 'THE RISE OF PALPATINE — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'RP-1', name:'The Secret Apprentice'},
      {n:'RP-2', name:'Advisor to Queen Amidala'},
      {n:'RP-3', name:'The New Supreme Chancellor'},
      {n:'RP-4', name:'Civil War with the Separatists'},
      {n:'RP-5', name:'Emergency Powers'},
      {n:'RP-6', name:'The Secret Geonosian Superweapon'},
      {n:'RP-7', name:'The Tale of Darth Plagueis'},
      {n:'RP-8', name:"The Jedi\'s Attempt to Seize Control"},
      {n:'RP-9', name:'Order 66'},
      {n:'RP-10', name:'The First Galactic Empire'},
      {n:'RP-11', name:'The Duel with Yoda'},
      {n:'RP-12', name:'Extracting Vader from Mustafar'},
      {n:'RP-13', name:'The Offspring of Anakin Skywalker'},
      {n:'RP-14', name:'Arrival at the Second Death Star'},
      {n:'RP-15', name:'Luring the Rebellion Into a Trap'},
      {n:'RP-16', name:'Tempting Luke Skywalker to the Dark Side'},
      {n:'RP-17', name:"Darth Vader\'s Betrayal"},
      {n:'RP-18', name:'Palpatine Resurrected'},
      {n:'RP-19', name:'The Secret Sith Fleet'},
      {n:'RP-20', name:'Final Battle with Rey & Kylo Ren'},
    ]
  },
  {
    id: 'starship-blueprints', type: 'insert', title: 'STARSHIP BLUEPRINTS — 15 CARDS',
    parallels: INS_P2,
    cards: [
      {n:'S-1', name:'The Millennium Falcon'},
      {n:'S-2', name:'The Razor Crest'},
      {n:'S-3', name:'The Ghost'},
      {n:'S-4', name:"Boba Fett\'s Starship"},
      {n:'S-5', name:'Fondor Haulcraft'},
      {n:'S-6', name:'The Marauder'},
      {n:'S-7', name:'Gauntlet Fighter'},
      {n:'S-8', name:"Darth Vader\'s TIE Fighter"},
      {n:'S-9', name:'Star Destroyer'},
      {n:'S-10', name:"The Mandalorian\'s N-1 Starfighter"},
      {n:'S-11', name:'Jedi T-6 Shuttle'},
      {n:'S-12', name:"Poe Dameron\'s X-Wing Fighter"},
      {n:'S-13', name:"Kylo Ren\'s TIE Silencer"},
      {n:'S-14', name:'The Night Buzzard'},
      {n:'S-15', name:'Snowspeeder'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'AUTOGRAPH CARDS — 95 CARDS',
    parallels: AUTO_P,
    cards: [
      {n:'AU-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'AU-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'AU-AE', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'AU-AL', name:'Alex Lawther', artist:'Karis Nemik'},
      {n:'AU-AM', name:'Alastair Mackenzie', artist:'Perrin Fertha'},
      {n:'AU-AS', name:'Andy Serkis', artist:'Kino Loy'},
      {n:'AU-B', name:'Joplin Sibtain', artist:'Brasso'},
      {n:'AU-BC', name:'Bronte Carmichael', artist:'Leida Mothma'},
      {n:'AU-BDT', name:'Benicio Del Toro', artist:'DJ'},
      {n:'AU-BL', name:'Billie Lourd', artist:'Lieutenant Kaydel Ko Connix'},
      {n:'AU-BM', name:'Ben Mendelsohn', artist:'Director Orson Krennic'},
      {n:'AU-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'AU-CC', name:'Crystal Clarke', artist:'Pammich Nerro Goode'},
      {n:'AU-CI', name:'Dee Tails', artist:'Cratinus'},
      {n:'AU-CP', name:'Chad Parker', artist:'Worker Padu Cherd'},
      {n:'AU-DG', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'AU-DGL', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'AU-DI', name:'Diana Lee Inosanto', artist:'Morgan Elsbeth'},
      {n:'AU-DKO', name:'Gabriel Fonseca', artist:'Duke Kayo Organa'},
      {n:'AU-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'AU-DP', name:'David Pasquesi', artist:"Twi\'lek Majordomo"},
      {n:'AU-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'AU-EC', name:'Emilia Clarke', artist:"Qi\'ra"},
      {n:'AU-EMC', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'AU-EW', name:'Evan Whitten', artist:'Jacen Syndulla'},
      {n:'AU-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'AU-FS', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'AU-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'AU-G', name:'Paul Blake', artist:'Greedo'},
      {n:'AU-GB', name:'Gary Beadle', artist:'Clem Andor'},
      {n:'AU-GF', name:'Grant Feely', artist:'Luke Skywalker'},
      {n:'AU-GH', name:'Guy Henry', artist:'Grand Moff Tarkin'},
      {n:'AU-GO', name:"Genevieve O\'Reilly", artist:'Mon Mothma'},
      {n:'AU-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'AU-HD', name:'Harrison Davis', artist:'Pommet Warrick'},
      {n:'AU-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'AU-HM', name:'Heath McGough', artist:'Groff Ditcher'},
      {n:'AU-HQ', name:'Hugh Quarshie', artist:'Captain Panaka'},
      {n:'AU-IF', name:'Isla Farris', artist:'Winta'},
      {n:'AU-II', name:'Ian Inigo', artist:'Cousin Niano Organa'},
      {n:'AU-IM', name:'Ian McDiarmid', artist:'The Emperor'},
      {n:'AU-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'AU-JG', name:'Julian Glover', artist:'General Maximilian Veers'},
      {n:'AU-JJ', name:'Julia Jones', artist:'Omera'},
      {n:'AU-JN', name:'Jennifer Beals', artist:'Garsa Fwip'},
      {n:'AU-JO', name:'Joanna Bennett', artist:'Tusken Warrior'},
      {n:'AU-JPG', name:'Jeryl Prescott Gallien', artist:'Aktropaw'},
      {n:'AU-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'AU-KL', name:'Nick Kellington', artist:'Bistan'},
      {n:'AU-KS', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'AU-KSA', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'AU-LAW', name:'Anton Lesser', artist:'Major Partagaz'},
      {n:'AU-LB', name:'Lee Boardman', artist:'Kravas Drezzer'},
      {n:'AU-LC', name:'Lily Cole', artist:'Lovey'},
      {n:'AU-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'AU-LNY', name:"Lupita Nyong\'o", artist:'Maz Kanata'},
      {n:'AU-LRB', name:'Lynn Robertson Bruce', artist:'D-0'},
      {n:'AU-LS', name:'Leilani Shiu', artist:'Jawa'},
      {n:'AU-MBO', name:'Mark Boone Jr.', artist:'Ranzar Malk'},
      {n:'AU-ME', name:'Maya Erskine', artist:'Sully Stark'},
      {n:'AU-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'AU-MK', name:'Mandy Kowalski', artist:'Camie'},
      {n:'AU-MM', name:'Molly Miller', artist:'Handmaiden Agira'},
      {n:'AU-MP', name:'Michael Pennington', artist:'Moff Jerjerrod'},
      {n:'AU-MQ', name:'Ming Qiu', artist:'Jedi Master Minas Velti'},
      {n:'AU-MR', name:'Mark Rolston', artist:'Captain Hayle'},
      {n:'AU-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'AU-MWE', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'AU-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'AU-NK', name:'Nalini Krishan', artist:'Barriss Offee'},
      {n:'AU-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'AU-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'AU-PD', name:'Paul Darnell', artist:'Marrok'},
      {n:'AU-PJ', name:'Peter Jacobson', artist:'Myn Weaver'},
      {n:'AU-PW', name:'Paul Warren', artist:'Doctor Quadpaw'},
      {n:'AU-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'AU-RB', name:'Ralph Brown', artist:'Ric Olié'},
      {n:'AU-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'AU-RF', name:'Rupert Friend', artist:'The Grand Inquisitor'},
      {n:'AU-RM', name:'Ryder McLaughlin', artist:'Wade Resselian'},
      {n:'AU-SB', name:'Skyler Bible', artist:'Fixer'},
      {n:'AU-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'AU-SKE', name:'Simone Kessell', artist:'Breha Organa'},
      {n:'AU-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'AU-SW', name:'Stephen Wight', artist:'Verlo Skiff'},
      {n:'AU-TF', name:'Tait Fletcher', artist:'Paz Vizsla'},
      {n:'AU-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'AU-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'AU-TR', name:'Tim Rose', artist:'Admiral Ackbar'},
      {n:'AU-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'AU-VB', name:'Vivien Lyra Blair', artist:'Princess Leia Organa'},
      {n:'AU-WC', name:'Wes Chatham', artist:'Captain Enoch'},
      {n:'AU-WH', name:'Werner Herzog', artist:'The Client'},
      {n:'AU-XJ', name:'Xavier Jimenez', artist:'Tusken Chief'},
      {n:'AU-YAT', name:'Ariana Greenblatt', artist:'Young Ahsoka Tano'},
    ]
  },
  {
    id: 'auto-dual', type: 'auto', title: 'DUAL AUTOGRAPH CARDS — 13 CARDS',
    parallels: MULTI_AUTO_P,
    cards: [
      {n:'DA-AO', name:"Omid Abtahi / Katy O\'Brian", artist:'Dr. Pershing / Elia Kane'},
      {n:'DA-BI', name:'Natasha Liu Bordizzo / Diana Lee Inosanto', artist:'Sabine Wren / Morgan Elsbeth'},
      {n:'DA-DB', name:'Natasha Liu Bordizzo / Rosario Dawson', artist:'Sabine Wren / Ahsoka Tano'},
      {n:'DA-DG', name:'Domhnall Gleeson / Adam Driver', artist:'General Hux / Kylo Ren'},
      {n:'DA-DM', name:'Lars Mikkelsen / Rosario Dawson', artist:'Grand Admiral Thrawn / Ahsoka Tano'},
      {n:'DA-LA', name:'Adria Arjona / Diego Luna', artist:'Bix Caleen / Cassian Andor'},
      {n:'DA-LC', name:'Diego Luna / Dave Chapman', artist:'Cassian Andor / B2EMO'},
      {n:'DA-LO', name:"Diego Luna / Genevieve O\'Reilly", artist:'Cassian Andor / Mon Mothma'},
      {n:'DA-MB', name:'Zach Braff / Ewan McGregor', artist:'Freck / Obi-Wan Kenobi'},
      {n:'DA-MW', name:'Temuera Morrison / Ming-Na Wen', artist:'Boba Fett / Fennec Shand'},
      {n:'DA-RD', name:'Adam Driver / Daisy Ridley', artist:'Kylo Ren / Rey'},
      {n:'DA-SG', name:'Kyle Soller / Denise Gough', artist:'Syril Karn / Dedra Meero'},
      {n:'DA-WO', name:"Genevieve O\'Reilly / Mary Elizabeth Winstead", artist:'Mon Mothma / Hera Syndulla'},
    ]
  },
  {
    id: 'auto-triple', type: 'auto', title: 'TRIPLE AUTOGRAPH CARDS — 7 CARDS',
    parallels: MULTI_AUTO_P,
    cards: [
      {n:'TA-FRN', name:"Harrison Ford / Lupita Nyong\'o / Daisy Ridley", artist:'Han Solo / Maz Kanata / Rey'},
      {n:'TA-HMC', name:'Mark Hamill / Carrie Fisher / Harrison Ford', artist:'Luke / Princess Leia / Han Solo'},
      {n:'TA-JLW', name:'Felicity Jones / Diego Luna / Forest Whitaker', artist:'Jyn Erso / Cassian Andor / Saw Gerrera'},
      {n:'TA-MBB', name:'Zach Braff / Ewan McGregor / Vivien Lyra Blair', artist:'Freck / Obi-Wan Kenobi / Princess Leia'},
      {n:'TA-MBF', name:'Vivien Lyra Blair / Grant Feely / Ewan McGregor', artist:'Princess Leia / Luke Skywalker / Obi-Wan Kenobi'},
      {n:'TA-MIC', name:'Moses Ingram / Ewan McGregor / Hayden Christensen', artist:'Reva / Obi-Wan Kenobi / Darth Vader'},
      {n:'TA-SVM', name:'Suzie McGrath / Myrna Valesco / Christopher Sean', artist:'Tam Ryvora / Torra Doza / Kazuda Xiono'},
    ]
  },
  {
    id: 'sketch', type: 'sketch', title: 'SKETCH CARD ARTISTS — 82 ARTISTS',
    parallels: [],
    cards: [
      {n:'SK-1', name:'Angel S Aviles', artist:'Sketch Card Artist'},
      {n:'SK-2', name:'Anthony Pietszak', artist:'Sketch Card Artist'},
      {n:'SK-3', name:'Basak Kahraman', artist:'Sketch Card Artist'},
      {n:'SK-4', name:'Bobby Blakey', artist:'Sketch Card Artist'},
      {n:'SK-5', name:'Brandon Klein', artist:'Sketch Card Artist'},
      {n:'SK-6', name:'Bryan Kaiser Tillman', artist:'Sketch Card Artist'},
      {n:'SK-7', name:'Cisco Rivera', artist:'Sketch Card Artist'},
      {n:'SK-8', name:'Clinton Yeager', artist:'Sketch Card Artist'},
      {n:'SK-9', name:'Dan Lawler', artist:'Sketch Card Artist'},
      {n:'SK-10', name:'Daniel M. Chavez', artist:'Sketch Card Artist'},
      {n:'SK-11', name:'Daniel P. Gorman', artist:'Sketch Card Artist'},
      {n:'SK-12', name:'Darrin Pepe', artist:'Sketch Card Artist'},
      {n:'SK-13', name:'David Sorensen', artist:'Sketch Card Artist'},
      {n:'SK-14', name:'David Willingham', artist:'Sketch Card Artist'},
      {n:'SK-15', name:'Debjit Kar', artist:'Sketch Card Artist'},
      {n:'SK-16', name:'Derek Johnson', artist:'Sketch Card Artist'},
      {n:'SK-17', name:'Derek Stevens', artist:'Sketch Card Artist'},
      {n:'SK-18', name:'Dirk Shearer', artist:'Sketch Card Artist'},
      {n:'SK-19', name:'Dove McHargue', artist:'Sketch Card Artist'},
      {n:'SK-20', name:'Dwayne Carpenter', artist:'Sketch Card Artist'},
      {n:'SK-21', name:'Emrah Cildir', artist:'Sketch Card Artist'},
      {n:'SK-22', name:'Emre Varlibas', artist:'Sketch Card Artist'},
      {n:'SK-23', name:'Eric Medina', artist:'Sketch Card Artist'},
      {n:'SK-24', name:'Gabe Farber', artist:'Sketch Card Artist'},
      {n:'SK-25', name:'Gregory Tilson', artist:'Sketch Card Artist'},
      {n:'SK-26', name:'Ian Mckesson', artist:'Sketch Card Artist'},
      {n:'SK-27', name:'Jackson Ong', artist:'Sketch Card Artist'},
      {n:'SK-28', name:'James Boyd', artist:'Sketch Card Artist'},
      {n:'SK-29', name:'Jason Saldajeno', artist:'Sketch Card Artist'},
      {n:'SK-30', name:'Jason Christner', artist:'Sketch Card Artist'},
      {n:'SK-31', name:'Jason Davies', artist:'Sketch Card Artist'},
      {n:'SK-32', name:'Jason Sobol', artist:'Sketch Card Artist'},
      {n:'SK-33', name:'Jay Manchand', artist:'Sketch Card Artist'},
      {n:'SK-34', name:'Jeffrey Benitez', artist:'Sketch Card Artist'},
      {n:'SK-35', name:'Jessica Hickman', artist:'Sketch Card Artist'},
      {n:'SK-36', name:'Joey Mason', artist:'Sketch Card Artist'},
      {n:'SK-37', name:'John Anthony Rodriguez', artist:'Sketch Card Artist'},
      {n:'SK-38', name:'Julie Hunt', artist:'Sketch Card Artist'},
      {n:'SK-39', name:'Kang Jing', artist:'Sketch Card Artist'},
      {n:'SK-40', name:'Karl Jones', artist:'Sketch Card Artist'},
      {n:'SK-41', name:'Keith Farnum', artist:'Sketch Card Artist'},
      {n:'SK-42', name:'Kevin Scott Jacobs', artist:'Sketch Card Artist'},
      {n:'SK-43', name:'Kirk Chavarria', artist:'Sketch Card Artist'},
      {n:'SK-44', name:'Krishna Sharma', artist:'Sketch Card Artist'},
      {n:'SK-45', name:'Limuel Pinzon', artist:'Sketch Card Artist'},
      {n:'SK-46', name:'Luke Seavers', artist:'Sketch Card Artist'},
      {n:'SK-47', name:'Marcia Dye', artist:'Sketch Card Artist'},
      {n:'SK-48', name:'Marlo Agunos', artist:'Sketch Card Artist'},
      {n:'SK-49', name:'Matt Stewart', artist:'Sketch Card Artist'},
      {n:'SK-50', name:'Matthew Maldonado', artist:'Sketch Card Artist'},
      {n:'SK-51', name:'Michael J Sealie', artist:'Sketch Card Artist'},
      {n:'SK-52', name:'Michael Mastermaker', artist:'Sketch Card Artist'},
      {n:'SK-53', name:'Mike Davidson', artist:'Sketch Card Artist'},
      {n:'SK-54', name:'Mike LaPeruta', artist:'Sketch Card Artist'},
      {n:'SK-55', name:'Mongola Das', artist:'Sketch Card Artist'},
      {n:'SK-56', name:'Neil Brady', artist:'Sketch Card Artist'},
      {n:'SK-57', name:'Neil Camera', artist:'Sketch Card Artist'},
      {n:'SK-58', name:'Nick Gribbon', artist:'Sketch Card Artist'},
      {n:'SK-59', name:'Phillip Trujillo', artist:'Sketch Card Artist'},
      {n:'SK-60', name:'Quinton Baker', artist:'Sketch Card Artist'},
      {n:'SK-61', name:'Rachel Jane', artist:'Sketch Card Artist'},
      {n:'SK-62', name:'Rebeca Louro', artist:'Sketch Card Artist'},
      {n:'SK-63', name:'Robert Demers', artist:'Sketch Card Artist'},
      {n:'SK-64', name:'Robert Garcia', artist:'Sketch Card Artist'},
      {n:'SK-65', name:'Rusty Gilligan', artist:'Sketch Card Artist'},
      {n:'SK-66', name:'Rutvig Vaid', artist:'Sketch Card Artist'},
      {n:'SK-67', name:'Ryan Harris', artist:'Sketch Card Artist'},
      {n:'SK-68', name:'Ryan Johnston', artist:'Sketch Card Artist'},
      {n:'SK-69', name:'Sam Barugh', artist:'Sketch Card Artist'},
      {n:'SK-70', name:'Sean Mathews', artist:'Sketch Card Artist'},
      {n:'SK-71', name:'Semra Bulut', artist:'Sketch Card Artist'},
      {n:'SK-72', name:'Shaow Siong', artist:'Sketch Card Artist'},
      {n:'SK-73', name:'Stephane Leonardi', artist:'Sketch Card Artist'},
      {n:'SK-74', name:'Steve Alce', artist:'Sketch Card Artist'},
      {n:'SK-75', name:'Todd Aaron Smith', artist:'Sketch Card Artist'},
      {n:'SK-76', name:'Traci Easterday', artist:'Sketch Card Artist'},
      {n:'SK-77', name:'Rico Dela Rosa', artist:'Sketch Card Artist'},
      {n:'SK-78', name:'Veronica Louro', artist:'Sketch Card Artist'},
      {n:'SK-79', name:'Veronica Smith', artist:'Sketch Card Artist'},
      {n:'SK-80', name:'Will Pleydon', artist:'Sketch Card Artist'},
      {n:'SK-81', name:'Yves Van Berlo', artist:'Sketch Card Artist'},
      {n:'SK-82', name:'Zach Woolsey', artist:'Sketch Card Artist'},
    ]
  },
];

export const PARALLELS = BASE_P;
export const AUTO_PARALLELS = AUTO_P;
export const INSERT_PARALLELS = INS_P;
